import { Encoder } from '@everyboard/lib';
import { Coord } from './Coord';
import { Move } from './Move';
export class MoveCoord extends Move {
    static getFallibleEncoder(generate) {
        return Encoder.tuple([Coord.encoder], (m) => [m.coord], (fields) => generate(fields[0]).get());
    }
    static getEncoder(generate) {
        return Encoder.tuple([Coord.encoder], (m) => [m.coord], (fields) => generate(fields[0]));
    }
    coord;
    constructor(x, y) {
        super();
        this.coord = new Coord(x, y);
    }
    equals(other) {
        return this === other || this.coord.equals(other.coord);
    }
}
